import React, { useState } from "react";
import "./register.css";
import axios from "axios";
import { useTranslation } from "react-i18next";
const EXPRESS_API = process.env.REACT_APP_EXPRESS_API;

function Register({ show, onClose }) {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formData, setFormData] = useState({
    nama: "",
    email: "",
    password: "",
    confirmPassword: "",
    agree: false,
  });
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleNextStep = async (e) => {
    e.preventDefault();
    setMessage("");
    if (!formData.nama.trim()) return setMessage(t("register.name_fill_warning"));
    if (!formData.email.trim()) return setMessage(t("register.email_fill_warning"));
    if (formData.password.length < 6)
      return setMessage(t("register.password_fill_warning"));
    if (formData.password !== formData.confirmPassword)
      return setMessage(t("register.pass_repass_mismatch"));
    if (!formData.agree)
      return setMessage(t("register.agree_warning"));

    setMessage("");
    try {
      await axios.post(
        `${EXPRESS_API}/api/v2/auth/register`,
        {
          nama: formData.nama,
          email: formData.email,
          password: formData.password
        },
        { headers: { "Content-Type": "application/json" } }
      );

      // Clear form and close modal
      setFormData({
        nama: "",
        email: "",
        password: "",
        confirmPassword: "",
        agree: false,
      });
      setMessage("Registrasi berhasil! Silakan masuk.");
      setTimeout(() => {
        onClose();
      }, 1500);

    } catch (err) {
      console.error("Error during register:", err.response?.data || err.message);
      setMessage(err.response?.data?.message || "Registrasi gagal, periksa kembali data Anda.");
    }
  };

  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content register-modal">
        <button
          className="close-btn-register"
          onClick={() => {
            onClose();
          }}
        >
          ✕
        </button>
        <>
          <h2>{t("register.title_step1")}</h2>
          <p className="register-subtitle">
            {t("register.subtitle_step1")}
          </p>

          <form className="register-form" onSubmit={handleNextStep}>
            <label>{t("register.name_label")}</label>
            <input
              name="nama"
              value={formData.nama}
              onChange={handleChange}
              placeholder={t("register.name_placeholder")}
              required
            />

            <label>{t("register.email_label")}</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder={t("register.email_placeholder")}
              required
            />
            <label>{t("register.password_label")}</label>
            <div className="password-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder={t("register.password_placeholder")}
                required
              />

              <span className="toggle-password" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? "🙈" : "👁️"}
              </span>
            </div>
            <label>{t("register.confirm_label")}</label>
            <div className="password-wrapper">
              <input
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                placeholder={t("register.confirm_placeholder")}
                required
              />

              <span className="toggle-password" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                {showConfirmPassword ? "🙈" : "👁️"}
              </span>
            </div>
            <label className="checkbox-label">
              <input
                type="checkbox"
                name="agree"
                checked={formData.agree}
                onChange={handleChange}
              />
              {t("register.agree_text")}{" "}
              <a href="/SK_lacakkas.pdf" className="syarat-link" target="_blank" rel="noopener noreferrer">
                {t("register.terms_link")}
              </a>
            </label>

            <button
              type="submit"
              className="btn-register"
              disabled={!formData.agree}
            >
              {t("register.btn_register")}
            </button>
            {message && <p className="register-message">{message}</p>}
          </form>
        </>
      </div>
    </div>
  );
}

export default Register;
